import axios_ from 'axios'
import Vue from 'vue'

const axios = axios_.create({
    baseURL: process.env.NODE_ENV === 'production' ? 'https://staff.pgo.mv' : 'http://staff.pgo.mv:4000',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
})

axios.interceptors.request.use(
    function(config){
        // do stuff
        return config
    },
    function(error){
        // do stuff
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    function(response){
        showNotifications(response.headers)
        return response
    },
    function(error){
        // do stuff
        let status = error.response ? error.response.status : 0;
        if(status == 401) {
            // Stale impersonation header is a common cause of 401 here. Clear
            // it before the redirect so the post-login boot doesn't re-attach
            // the same bad header and trigger an infinite redirect loop.
            try { localStorage.removeItem('ImpersonatingUser') } catch (e) { /* noop */ }
            window.location.href = 'https://staff.pgo.mv/api/login'
        }
        else if(status >= 400 && error.response){
            // Callers can opt out of the global toast by passing
            //   axios.get(url, { silentError: true })          // any 4xx
            //   axios.get(url, { silentError: [403, 404] })     // specific codes
            // Used by read-only fetches (e.g. TodoDetailModal's activity /
            // files / comments) where a permission failure should silently
            // render empty rather than blast a "Not authorized" toast.
            const silent = error.config?.silentError
            const shouldSilence = silent === true
                || (Array.isArray(silent) && silent.includes(status))
            if(!shouldSilence) {
                if(error.response.headers['x-notification'])
                    showNotifications(error.response.headers)
                else if(error.response.data.message) Vue.$toast.error(error.response.data.message)
                else Vue.$toast.error(`${error.response.status}: ${error.response.statusText}`)
            }
        }
        return Promise.reject(error);
    }
)

const showNotifications = function(headers){
    let notifications = [];
    if(headers['x-notification']) {
        notifications = JSON.parse(headers['x-notification'])
    }
    notifications.map((notification) => {
        if(notification.type === 'info') {
            console.info(notification.type + ' : ' + notification.message)
        } else {
            Vue.$toast(notification.message, { type: notification.type })
        }
        
    }) 
}

export default axios;